/* eslint-disable no-unused-vars */
import Login from './login';
import messageApp from './message_app';

export default function agency() {
  return (
    <>
      <Login />
      <messageApp />
    </>
  );
}
